import { privateRoutes } from './private.routes';
import { bodegaRoutes } from './bodega.routes';
import { viticultorRoutes } from './viticultor.routes';
import { publicRoutes } from './public.routes';

export function createRoutes(auth, layouts) {
    if (!auth.isLogged) return publicRoutes(layouts);

    if (auth.user.roles.some(r => r.id === 'Bodega'))
        return bodegaRoutes(layouts, auth);

    if (auth.user.roles.some(r => r.id === 'Viticultor'))
        return viticultorRoutes(layouts, auth);

    return privateRoutes(layouts);
}
